import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import RedefinirSenha from "@/pages/RedefinirSenha";

export const Route = createFileRoute("/redefinir-senha")({
  head: () => seoHead({
    title: "Redefinir Senha | Shopping do Bem",
    description: "Redefina sua senha do Shopping do Bem.",
    path: "/redefinir-senha", noindex: true,
  }),
  component: RedefinirSenha,
});
